// action
import {
    SAVE_ROLE,
    SAVE_ROLE_FAIL,
    SAVE_ROLE_SUCCESS,
    SAVE_ROLE_RESET
} from '../action/saveRoleAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SAVE_ROLE:
            return {
                ...state,
                apiState: "loading"
            }
        case SAVE_ROLE_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SAVE_ROLE_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case SAVE_ROLE_RESET:
            return initialState
        default:
            return state
    }
}